module.exports = __webpack_public_path__ + "img/video_black_icon.2b2600aa.svg";